export const NoteEntityTypes = {
    VEHICLE: 1,
    VEHICLE_DETAIL: 2,
    ACTIVITY: 3,
    MECHANICAL_WORK: 4,
    VEHICLE_IMAGE: 5,
    LOT: 6,
    TRANSPORT: 7,
    WORKORDER_ATTACHMENT: 8,
    ISSUE_TRACKER: 9,
    ISSUE_TRACKER_STATUS: 10,
    RESERVATION: 11,
    TRANSPORTINVOICES: 12,
    STORAGEINVOICES: 13,
    VENDORINVOICES: 14
}

export const NoteSource = {
    FIELD: 1,
    OFFICE: 2,
    SYSTEM: 3,
}

export const NOTE_SOURCE_TABS = [
    { source: NoteSource.FIELD, label: 'Field Notes', emptyText: 'No Field Notes' },
    { source: NoteSource.OFFICE, label: 'Office Notes', emptyText: 'No Office Notes' },
    { source: NoteSource.SYSTEM, label: 'System Notes', emptyText: 'No System Notes' },
]
